import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

// --- ICONS ---
const Icons = {
  HeartOutline: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" /></svg>,
  HeartSolid: () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-red-600"><path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" /></svg>,
  Bag: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 5c.17.678-.369 1.493-1.077 1.493H4.214a1.125 1.125 0 01-1.077-1.493l1.263-5a1.125 1.125 0 011.078-.853h13.04c.525 0 .985.349 1.078.853z" /></svg>,
  Search: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>,
  Close: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>,
  Phone: () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path fillRule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 5.25V4.5z" clipRule="evenodd" /></svg>,
  Mail: () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" /><path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" /></svg>,
};

// --- BANNERS ---
const banners = [
  { id: 1, image: "/banners/1.jpg", title: "The Royal Kanjeevaram", subtitle: "Woven heritage for the modern bride." },
  { id: 2, image: "/banners/2.jpg", title: "The Pastel Edit", subtitle: "Soft hues for elegant day weddings." },
  { id: 3, image: "/banners/3.jpg", title: "Weaves of Banaras", subtitle: "Experience the timeless grace of silk." },
  { id: 4, image: "/banners/4.jpg", title: "Handloom Heritage", subtitle: "Authentic craftsmanship in every thread." },
  { id: 5, image: "/banners/5.jpg", title: "Festival Ready", subtitle: "Shine bright with our Zari collection." }
];

function Shop() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem('bramari_cart');
    return saved ? JSON.parse(saved) : [];
  });
  const [isCartOpen, setIsCartOpen] = useState(false);

  const [wishlist, setWishlist] = useState(() => {
    const saved = localStorage.getItem('bramari_wishlist');
    return saved ? JSON.parse(saved) : [];
  });
  const [isWishlistOpen, setIsWishlistOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortOption, setSortOption] = useState("newest");
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Newsletter State
  const [emailInput, setEmailInput] = useState("");

  const SELLER_NUMBER = "919491950909"; 
  const API_URL = "https://bramari.onrender.com";
  
  const categories = ["All", "Silk", "Cotton", "Georgette", "Wedding", "Party Wear"];

  // --- HERO SLIDER ---
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000); 
    return () => clearInterval(timer);
  }, []); 

  // --- FETCH & TRACK ---
  useEffect(() => {
    setTimeout(() => {
      fetch(`${API_URL}/products`)
        .then(res => res.json())
        .then(data => {
            if (Array.isArray(data)) {
                setProducts(data);
                setFilteredProducts([...data].reverse());
                setLoading(false);
            } else {
                setProducts([]);
                setFilteredProducts([]);
                setLoading(false);
            }
        })
        .catch(err => {
            console.error("Network Error:", err);
            setLoading(false);
        });
    }, 1000);

    fetch(`${API_URL}/track-visit`).catch(err => console.log("Tracking error (ignored):", err));
  }, []);

  useEffect(() => localStorage.setItem('bramari_wishlist', JSON.stringify(wishlist)), [wishlist]);
  useEffect(() => localStorage.setItem('bramari_cart', JSON.stringify(cart)), [cart]);

  useEffect(() => {
    let result = [...products];
    if (selectedCategory !== "All") result = result.filter(p => p.fabric.toLowerCase().includes(selectedCategory.toLowerCase()) || p.occasion.toLowerCase().includes(selectedCategory.toLowerCase()));
    if (searchTerm) result = result.filter(p => p.title.toLowerCase().includes(searchTerm.toLowerCase()) || p.fabric.toLowerCase().includes(searchTerm.toLowerCase()));
    if (sortOption === "lowToHigh") result.sort((a, b) => a.price - b.price);
    else if (sortOption === "highToLow") result.sort((a, b) => b.price - a.price);
    setFilteredProducts(result);
  }, [searchTerm, selectedCategory, sortOption, products]);

  const addToCart = (product) => {
    if (cart.some(item => item._id === product._id)) {
        toast.error("Already in your cart!", { position: "bottom-center", icon: '🚫' });
        return;
    }
    setCart([...cart, product]);
    toast.success("Added to Cart!", { position: "bottom-center", style: { background: '#4A0404', color: '#fff' } });
  };

  const removeFromCart = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1);
    setCart(newCart);
  };

  const toggleWishlist = (product) => {
    const exists = wishlist.find(item => item._id === product._id);
    if (exists) {
      setWishlist(wishlist.filter(item => item._id !== product._id));
      toast.error("Removed from Wishlist", { position: "bottom-center" });
    } else {
      setWishlist([...wishlist, product]);
      toast.success("Saved to Wishlist", { position: "bottom-center" });
    }
  };
  const isInWishlist = (id) => wishlist.some(item => item._id === id);

  const handleCheckout = () => {
    if (cart.length === 0) return;
    let message = "Hello! I would like to place an order for:\n\n";
    cart.forEach((item, index) => { 
        const itemLink = `${window.location.origin}/product/${item._id}`;
        message += `${index + 1}. *${item.title}* (₹${item.price})\n   🔗 ${itemLink}\n\n`; 
    });
    const total = cart.reduce((sum, item) => sum + item.price, 0);
    message += `*Total Value:* ₹${total}\n\nAre these available?`;
    window.open(`https://wa.me/${SELLER_NUMBER}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleSubscribe = () => {
    if (!emailInput || !emailInput.includes('@')) {
        toast.error("Please enter a valid email address.");
        return;
    }
    toast.success("Welcome to the family! You've successfully subscribed. ✨", { 
        duration: 4000,
        style: { background: '#4A0404', color: '#fff' },
        icon: '💌'
    });
    setEmailInput("");
  };

  const SkeletonCard = () => (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-100 animate-pulse">
      <div className="aspect-[3/4] bg-gray-200"></div>
      <div className="p-3 space-y-2">
        <div className="h-3 bg-gray-200 rounded w-3/4"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-saree-cream flex flex-col font-sans overflow-x-hidden relative">
      <Toaster />
      
      {/* 1. ANNOUNCEMENT BAR */}
      <div className="bg-saree-maroon text-saree-gold text-[10px] md:text-xs font-bold py-1.5 overflow-hidden z-[60] relative">
        <div className="whitespace-nowrap animate-marquee flex gap-10">
          <span>✨ FREE SHIPPING ON ORDERS ABOVE ₹5000</span>
          <span>💎 AUTHENTIC HANDLOOM SILK</span>
          <span>🚚 WORLDWIDE SHIPPING AVAILABLE</span>
          <span>✨ FREE SHIPPING ON ORDERS ABOVE ₹5000</span>
          <span>💎 AUTHENTIC HANDLOOM SILK</span>
          <span>🚚 WORLDWIDE SHIPPING AVAILABLE</span>
        </div>
      </div>

      {/* --- NAVBAR (NOT STICKY - FIXED as per request) --- */}
      <nav className="relative w-full z-50 bg-white/95 backdrop-blur-md text-saree-maroon p-3 md:p-4 shadow-md flex justify-between items-center px-4 md:px-8">
        <div className="flex items-center gap-3">
            <img src="/logo.jpg" alt="Bramari Logo" className="h-10 w-10 md:h-14 md:w-14 rounded-full object-cover border-2 border-saree-gold shadow-md" />
            <h1 className="text-xl md:text-3xl font-serif font-bold tracking-wider text-saree-maroon">Bramari</h1>
        </div>

        <div className="flex gap-4 items-center">
           <button onClick={() => setIsWishlistOpen(true)} className="relative hover:scale-110 transition p-2">
             <Icons.HeartOutline />
             {wishlist.length > 0 && <span className="absolute -top-1 -right-1 bg-saree-maroon text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">{wishlist.length}</span>}
           </button>
           <button onClick={() => setIsCartOpen(true)} className="relative hover:scale-110 transition p-2">
             <Icons.Bag />
             {cart.length > 0 && <span className="absolute -top-1 -right-1 bg-saree-maroon text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">{cart.length}</span>}
           </button>
        </div>
      </nav>

      {/* HERO SLIDER */}
      <div className="relative w-full h-[450px] md:h-[650px] overflow-hidden bg-saree-maroon">
        {banners.map((banner, index) => (
          <div 
            key={banner.id} 
            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
          >
            <img 
                src={banner.image} 
                alt="Banner" 
                className={`w-full h-full object-cover transform transition-transform duration-[10000ms] ease-linear ${index === currentSlide ? 'scale-105' : 'scale-100'}`} 
                onError={(e) => { e.target.src = "https://via.placeholder.com/1500x800/4a0404/ffffff?text=Bramari+Silks"; }} 
            />
            <div className="absolute inset-0 bg-gradient-to-t from-saree-maroon via-saree-maroon/20 to-transparent flex flex-col items-center justify-center text-center px-4">
              <div className="max-w-3xl animate-slideUp">
                 <h2 className="text-4xl md:text-7xl font-serif font-bold mb-4 drop-shadow-2xl text-saree-gold">{banner.title}</h2>
                 <p className="text-lg md:text-2xl text-white/95 mb-8 font-light tracking-wider drop-shadow-md">{banner.subtitle}</p>
                 <button onClick={() => document.getElementById('collection').scrollIntoView({ behavior: 'smooth' })} className="bg-white/10 backdrop-blur border border-white/40 text-white px-8 py-3 rounded-full font-bold uppercase tracking-[0.2em] hover:bg-saree-gold hover:text-saree-maroon transition shadow-2xl text-xs md:text-sm">Explore Collection</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div id="collection" className="flex-grow max-w-7xl mx-auto px-2 md:px-6 py-6 w-full bg-white rounded-t-[30px] -mt-8 relative z-10 shadow-[0_-10px_40px_rgba(0,0,0,0.05)]">
        
        {/* FILTERS & SEARCH */}
        <div className="flex flex-col lg:flex-row gap-4 mb-8 items-center justify-between p-2 sticky top-0 z-30 bg-white/95 backdrop-blur pb-4 border-b border-gray-100">
          <div className="flex gap-2 overflow-x-auto w-full lg:w-auto no-scrollbar items-center pb-1">
            {categories.map(cat => (
              <button key={cat} onClick={() => setSelectedCategory(cat)} className={`px-4 py-1.5 rounded-full text-xs md:text-sm font-bold whitespace-nowrap transition border ${selectedCategory === cat ? "bg-saree-maroon text-white border-saree-maroon" : "bg-gray-50 text-gray-600 border-gray-200 hover:border-saree-maroon"}`}>{cat}</button>
            ))}
          </div>
          <div className="flex gap-2 w-full lg:w-auto">
            <div className="relative w-full">
              <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full pl-9 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-saree-maroon text-sm" />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><Icons.Search /></div>
            </div>
            <select value={sortOption} onChange={(e) => setSortOption(e.target.value)} className="p-2 bg-gray-50 border border-gray-200 rounded-lg text-xs font-bold text-gray-700 outline-none cursor-pointer">
              <option value="newest">Newest</option>
              <option value="lowToHigh">Price: Low-High</option>
              <option value="highToLow">Price: High-Low</option>
            </select>
          </div>
        </div>

        {/* SECONDARY BANNER */}
        <div className="mb-10 mx-2 rounded-2xl overflow-hidden relative h-52 md:h-80 shadow-lg group cursor-pointer">
            <img 
                src="/banners/promo.jpg" 
                alt="Promo" 
                className="w-full h-full object-cover transition duration-1000 group-hover:scale-105 brightness-[0.7]" 
                onError={(e) => { e.target.src = "https://via.placeholder.com/1500x500/4a0404/ffffff?text=Bridal+Collection"; }}
            />
            <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-6 border-white/20 m-3 border rounded-xl">
                <span className="text-saree-gold font-bold tracking-[0.3em] uppercase text-[10px] md:text-xs mb-2 bg-black/60 px-3 py-1 rounded-full backdrop-blur-md">Exclusive</span>
                <h3 className="text-3xl md:text-6xl font-serif text-white font-bold mb-4 drop-shadow-lg">The Bridal Edit</h3>
            </div>
        </div>

        {/* PRODUCTS GRID (Grid Images are Swipeable Here) */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-8 px-2">
          {loading ? [...Array(6)].map((_, i) => <SkeletonCard key={i} />) : filteredProducts.length === 0 ? <div className="col-span-full text-center py-20 text-gray-500">No sarees found.</div> : 
             filteredProducts.map((saree) => (
              <div key={saree._id} className="bg-white rounded-lg overflow-hidden border border-gray-100 group flex flex-col relative hover:shadow-xl transition-all duration-300">
                
                <button onClick={() => toggleWishlist(saree)} className="absolute top-2 right-2 z-20 bg-white/80 backdrop-blur p-1.5 rounded-full shadow-sm text-saree-maroon hover:scale-110 transition">
                    {isInWishlist(saree._id) ? <Icons.HeartSolid /> : <Icons.HeartOutline />}
                </button>

                {/* --- SWIPEABLE IMAGE CAROUSEL (For Grid) --- */}
                <div className="relative w-full aspect-[3/4] bg-gray-50 overflow-hidden">
                   {saree.images && saree.images.length > 0 ? (
                       <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide w-full h-full">
                           {saree.images.map((img, idx) => (
                               <div key={idx} className="w-full h-full flex-shrink-0 snap-center relative">
                                   <Link to={`/product/${saree._id}`}>
                                     <img 
                                        src={img.startsWith('data:') ? img : `data:image/jpeg;base64,${img}`} 
                                        alt={saree.title} 
                                        className="w-full h-full object-cover" 
                                        loading="lazy"
                                     />
                                   </Link>
                               </div>
                           ))}
                       </div>
                   ) : <div className="w-full h-full flex items-center justify-center text-gray-300">No Image</div>}
                   
                   {/* Multiple Photos Indicator */}
                   {saree.images && saree.images.length > 1 && (
                       <div className="absolute bottom-2 right-2 bg-black/50 text-white text-[10px] px-2 py-0.5 rounded-full backdrop-blur-sm pointer-events-none">
                           +{saree.images.length - 1}
                       </div>
                   )}
                </div>

                <div className="p-3 flex flex-col flex-grow">
                  <div className="text-[10px] text-gray-400 uppercase tracking-widest mb-1 truncate">{saree.fabric}</div>
                  <Link to={`/product/${saree._id}`}><h3 className="text-sm md:text-lg font-serif font-semibold text-gray-900 mb-1 leading-tight hover:text-saree-maroon cursor-pointer line-clamp-2 min-h-[2.5em]">{saree.title}</h3></Link>
                  <div className="flex items-center gap-2 mb-3 mt-auto">
                    <span className="text-saree-maroon font-bold text-base md:text-lg">₹{saree.price.toLocaleString('en-IN')}</span>
                    <span className="text-gray-400 line-through text-xs">₹{Math.round(saree.price * 1.2).toLocaleString('en-IN')}</span>
                  </div>
                  <button onClick={() => addToCart(saree)} className="w-full bg-white border border-saree-maroon text-saree-maroon font-bold py-2 rounded text-xs uppercase tracking-wider hover:bg-saree-maroon hover:text-white transition flex items-center justify-center gap-1 active:scale-95">Add to Cart</button>
                </div>
              </div>
            ))
          }
        </div>
      </div>

      {/* 2. NEWSLETTER SECTION (FUNCTIONAL) */}
      <div className="bg-gray-50 py-12 mt-12 border-t border-gray-100">
          <div className="max-w-7xl mx-auto px-6 text-center">
              <h3 className="text-2xl font-serif text-gray-800 mb-4">Join the Bramari Family</h3>
              <p className="text-gray-500 mb-6 text-sm">Subscribe to receive updates and exclusive deals.</p>
              <div className="flex justify-center max-w-md mx-auto gap-2">
                  <input 
                    type="email" 
                    placeholder="Enter your email" 
                    className="w-full p-3 rounded border border-gray-300 text-sm focus:outline-none focus:border-saree-maroon"
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                  />
                  <button 
                    onClick={handleSubscribe} 
                    className="bg-saree-maroon text-white px-6 py-3 rounded text-sm uppercase font-bold hover:bg-opacity-90"
                  >
                    Subscribe
                  </button>
              </div>
          </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-saree-maroon text-white pt-16 pb-12">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
                <img src="/logo.jpg" alt="Logo" className="h-16 w-16 rounded-full border border-saree-gold" />
                <h3 className="text-2xl font-serif font-bold text-saree-gold">Bramari</h3>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed max-w-sm font-serif italic">"Tradition in every thread. Handpicked elegance for you."</p>
          </div>
          <div>
            <h4 className="font-bold mb-4 text-saree-gold uppercase tracking-wider text-xs">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><a href="tel:+919491950909" className="hover:text-white flex items-center gap-2"><Icons.Phone /> +91 94919 50909</a></li>
              <li><a href="mailto:bramarisilks@gmail.com" className="hover:text-white flex items-center gap-2"><Icons.Mail /> bramarisilks@gmail.com</a></li>
            </ul>
          </div>
        </div>
        <div className="text-center border-t border-white/10 pt-8 text-xs text-gray-400">© 2025 Bramari Fashion.</div>
      </footer>

      {/* CART SIDEBAR */}
      {isCartOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex justify-end backdrop-blur-sm transition-opacity">
          <div className="bg-white w-full md:w-96 h-full p-6 shadow-2xl flex flex-col animate-slideIn">
            <div className="flex justify-between items-center border-b pb-4 mb-4">
              <h2 className="text-xl font-serif text-saree-maroon flex items-center gap-2"><Icons.Bag /> Cart ({cart.length})</h2>
              <button onClick={() => setIsCartOpen(false)}><Icons.Close /></button>
            </div>
            <div className="flex-grow overflow-y-auto pr-1">
              {cart.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-gray-400"><Icons.Bag /><p>Empty Cart</p></div> : cart.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3 mb-4 border-b border-gray-50 pb-4">
                    <div className="w-16 h-20 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                        {item.images && <img src={item.images[0].startsWith('data:') ? item.images[0] : `data:image/jpeg;base64,${item.images[0]}`} alt="thumb" className="w-full h-full object-cover" />}
                    </div>
                    <div className="flex-grow">
                      <p className="font-semibold text-sm text-gray-800 line-clamp-1">{item.title}</p>
                      <p className="text-sm font-bold text-saree-maroon">₹{item.price.toLocaleString('en-IN')}</p>
                    </div>
                    <button onClick={() => removeFromCart(idx)} className="text-gray-400 hover:text-red-500 p-1"><Icons.Close className="w-4 h-4" /></button>
                  </div>
              ))}
            </div>
            <div className="border-t pt-4 mt-auto">
              <div className="flex justify-between text-lg font-bold mb-4 text-saree-maroon"><span>Total</span><span>₹{cart.reduce((sum, item) => sum + item.price, 0).toLocaleString('en-IN')}</span></div>
              <button onClick={handleCheckout} className="w-full bg-green-600 text-white py-3 rounded-lg font-bold shadow-lg hover:bg-green-700 transition flex justify-center items-center gap-2 text-sm uppercase tracking-wider">Checkout on WhatsApp</button>
            </div>
          </div>
        </div>
      )}

      {/* WISHLIST SIDEBAR */}
      {isWishlistOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex justify-end backdrop-blur-sm">
          <div className="bg-white w-full md:w-96 h-full p-6 shadow-2xl flex flex-col border-l-4 border-saree-gold animate-slideIn">
            <div className="flex justify-between items-center border-b pb-4 mb-4">
              <h2 className="text-xl font-serif text-saree-maroon flex items-center gap-2"><Icons.HeartSolid /> Wishlist</h2>
              <button onClick={() => setIsWishlistOpen(false)}><Icons.Close /></button>
            </div>
            <div className="flex-grow overflow-y-auto pr-1">
              {wishlist.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-gray-400"><Icons.HeartOutline /><p>Empty Wishlist</p></div> : wishlist.map((item) => (
                  <div key={item._id} className="flex items-start gap-3 mb-4 border-b border-gray-50 pb-4">
                    <div className="w-16 h-20 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                       {item.images && <img src={item.images[0].startsWith('data:') ? item.images[0] : `data:image/jpeg;base64,${item.images[0]}`} alt="thumb" className="w-full h-full object-cover" />}
                    </div>
                    <div className="flex-grow">
                      <p className="font-semibold text-sm text-gray-800 line-clamp-1">{item.title}</p>
                      <p className="text-sm font-bold text-saree-maroon mb-2">₹{item.price.toLocaleString('en-IN')}</p>
                      <button onClick={() => { addToCart(item); toggleWishlist(item); }} className="text-[10px] bg-saree-maroon text-white px-3 py-1 rounded uppercase hover:bg-opacity-90">Add to Cart</button>
                    </div>
                    <button onClick={() => toggleWishlist(item)} className="text-gray-400 hover:text-red-500 p-1"><Icons.Close className="w-4 h-4" /></button>
                  </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Shop;